import Axios from "axios";
import User from "./User";
import store from "../src/store";

class ServicesClass {

  constructor() {
    this.services = /** @type {Service[]} */ ([]);
    this.categories = /** @type {Category[]} */ ([]);
    this._lock = false;
  }

  /**
   * @param {number} id
   */
  get(id) {
    for (let service of this.services) {
      if (service.id == id) {
        return service;
      }
    }
    return null;
  }

  /**
   * @param {number} id
   */
  getCategory(id) {
    for (let category of this.categories) {
      if (category.id == id) {
        return category;
      }
    }
    return null;
  }

  /**
   * @private
   */
  async init(forceHumaniti) {
    let categories = await Axios.get(CONFIG.urlServer + "/api/service_categories", {
      params: {
        property: !forceHumaniti ? store.state.property : undefined,
        organization: forceHumaniti ? 'humaniti' : undefined,
        perPage: 100
      }
    });

    let newCategories = [];
    for (let category of categories.data.data) {
      newCategories.push(new Category(category));
    }
    let result = await Axios.get(CONFIG.urlServer + "/api/services", {
      params: {
        property: !forceHumaniti ? store.state.property : undefined,
        organization: forceHumaniti ? 'humaniti' : store.state.organization,
        perPage: 100
      }
    });
    let newServices = [];
    for (let service of result.data.data) {
      let newService = new Service(service);
      newServices.push(newService);
      for (let category of newCategories) {
        if (category.id == newService.category) {
          category.services.push(newService);
          break;
        }
      }
    }
    this.services = newServices;
    this.categories = newCategories;
    this._lock = false;
  }

}

/**
 * @typedef CategoryDefinition
 * @property {number} id
 * @property {{fr: string, en: string}} name
 * @property {boolean} deleted
 */

export class Category {

  /**
   * @param {CategoryDefinition} definition
   */
  constructor(definition) {
    this.id = definition.id;
    this.name = definition.name;
    this.deleted = definition.deleted;
    this.services = /** @type {Service[]} */ ([]);
  }

}

/**
 * @typedef OpeningHours
 * @property {{open: boolean, hours: {from: string, to: string}[]}} monday
 * @property {{open: boolean, hours: {from: string, to: string}[]}} tuesday
 * @property {{open: boolean, hours: {from: string, to: string}[]}} wednesday
 * @property {{open: boolean, hours: {from: string, to: string}[]}} thursday
 * @property {{open: boolean, hours: {from: string, to: string}[]}} friday
 * @property {{open: boolean, hours: {from: string, to: string}[]}} saturday
 * @property {{open: boolean, hours: {from: string, to: string}[]}} sunday
 */

/**
 * @typedef ServiceDefinition
 * @property {number} id
 * @property {number} category
 * @property {{fr: string, en: string}} name
 * @property {{fr: string, en: string}} description
 * @property {boolean} active
 * @property {{tag: string, priority: number, id: number, name: string, url: string}} icon
 * @property {{tag: string, priority: number, id: number, name: string, url: string}[]} images
 * @property {OpeningHours} hours
 * @property {string} link
 * @property {number} maximumActiveBookingsAllowedPerUser
 * @property {number} maximumActiveBookingsAllowedPerUnit
 * @property {string} phoneNumber
 * @property {string} email
 * @property {boolean} availableOnlyForUserSignedOnLease
 */

export class Service {

  /**
   * @param {ServiceDefinition} definition
   */
  constructor(definition) {
    this.id = definition.id;
    this.category = definition.category;
    this.name = definition.name;
    this.description = definition.description;
    this.active = definition.active;
    this.icon = definition.icon ? definition.icon.url : null;
    this.hours = definition.hours;
    this.link = definition.link;
    this.externalLinks = definition.externalLinks;
    this.maxActiveBookingPerUser = definition.maximumActiveBookingsAllowedPerUser;
    this.maxActiveBookingPerUnit = definition.maximumActiveBookingsAllowedPerUnit;
    this.phoneNumber = definition.phoneNumber;
    this.email = definition.email;
    this.images = definition.images.map(i => i.url);
    this.documents = definition.documents;
    this.showAvailableSchedulesForDate = definition.showAvailableSchedulesForDate;
    this.availableOnlyForUserSignedOnLease = definition.availableOnlyForUserSignedOnLease;

  }

}

let Services = new ServicesClass();
export default Services;
